<cc-ng1-phone-number-settings
  [number]="number"
  [msisdn]="msisdn"
  [plan]="plan"
  [hasAutoAppliedEeaMsisdn]="hasAutoAppliedEeaMsisdn"
  *ngIf="number && msisdn"></cc-ng1-phone-number-settings>
